import { Box, Typography } from '@mui/material';
import { BarPlot, ChartsAxisHighlight, ChartsLegend, ChartsXAxis, ChartsYAxis } from '@mui/x-charts';
import { ResponsiveChartContainer } from '@mui/x-charts/ResponsiveChartContainer';
import { useMemo } from 'react';
import { BoxWithHeader } from '../common';
import { DealerAccidentsOverviewProps } from './types';

export const AllDealersAccidentReasonAcceptanceOverview = ({ graphData, date }: DealerAccidentsOverviewProps) => {
  if (!graphData) return null;

  const chartData = useMemo(() => {
    const sourceTypes = graphData.period[0]?.values.countAcceptedBySource.map((source) => source.type) || [];

    const sourceCounts = sourceTypes.map((sourceType) =>
      graphData.period.reduce((total, period) => {
        const sourceData = period.values.countAcceptedBySource.find((s) => s.type === sourceType);
        return total + (sourceData?.count || 0);
      }, 0)
    );

    return {
      sourceTypes: graphData.period[0]?.values.countAcceptedBySource.map((source) => source.label) || [],
      sourceCounts
    };
  }, [graphData]);

  return (
    <BoxWithHeader
      title={
        <>
          <Typography variant="h6" fontWeight="bold">
            Řešené nehody - zdroje hlášení
          </Typography>
          <Typography variant="body2" color="gray">
            {`Přehled zdrojů u hlášených nehod (${date})`}
          </Typography>
        </>
      }
    >
      <Box sx={{ width: '100%', height: '400px' }}>
        <ResponsiveChartContainer
          skipAnimation
          margin={{ left: 50, bottom: 100 }}
          series={[
            {
              type: 'bar',
              data: chartData.sourceCounts,
              label: 'Počet přijatých hlášení',
              color: 'green'
            }
          ]}
          xAxis={[
            {
              data: chartData.sourceTypes,
              scaleType: 'band',
              id: 'x-axis'
            }
          ]}
          yAxis={[
            {
              id: 'y-axis',
              scaleType: 'linear'
            }
          ]}
        >
          <BarPlot borderRadius={2} barLabel="value" />
          <ChartsXAxis
            position="bottom"
            tickLabelStyle={{
              angle: -45,
              textAnchor: 'end',
              fontSize: 10
            }}
          />
          <ChartsYAxis label="Počet přijetí" position="left" />
          <ChartsLegend position={{ vertical: 'bottom', horizontal: 'middle' }} />
          <ChartsAxisHighlight />
        </ResponsiveChartContainer>
      </Box>
    </BoxWithHeader>
  );
};
